// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-height[data-v-39a157c1] {\n  position: relative;\n  width: 100%;\n  max-height: 5.5rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 1px;\n}\n", ""]);
// Exports
module.exports = exports;
